import { DeliveryProvider, OFFER_KIND, PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  customer_info: {
    dummy_order: 'Encomenda de teste',
    ordered_at: 'Encomendado às:',
  },
  delivery_info: {
    info: 'Info de entrega:',
    note: 'Observação:',
  },
  schedule_info: {
    pickup: 'Recolha',
    delivery: 'Entrega',
    room_service_location: {
      room_service: 'Quarto',
      table_service: 'Mesa',
    },
    wish_time: 'Hora desejada:',
    confirmed_time: 'Hora confirmada:',
    driver_arrival_time: 'Hora de recolha do estafeta:',
    external_delivery: 'A encomenda é entregue por um estafeta externo de {{carrier}}',
    order_instructions: 'Instruções da encomenda:',
  },
  products: {
    item: 'Artigo:',
  },
  discount_breakdown: {
    label: 'Desconto',
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Desconto percentual sobre total aplicado',
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Desconto percentual sobre produtos aplicado',
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Desconto em valor sobre produtos aplicado',
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Desconto em valor sobre total aplicado',
    [OFFER_KIND.BOGO]: 'Bogo aplicado',
    [OFFER_KIND.BOGO_HALF_PRICE]: 'Bogo a meio preço aplicado',
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Artigo grátis por produtos aplicado',
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Artigo grátis por total aplicado',
    GiftCard: 'Cartão oferta aplicado',
    Reward: 'Pontos de fidelidade aplicados',
    CashbackAccount: 'Pontos de fidelidade aplicados',
    PromoCodeComponent: 'Promoção aplicada',
    Offer: 'Oferta aplicada',
  },
  payment_breakdown: {
    price: 'Preço:',
    subtotal: 'Subtotal',
    delivery_fee: 'Taxa de entrega',
    tips: 'Gorjeta',
    processing_fee: 'Taxa de serviço online',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'Taxa PayPal',
    },
    tax: 'Impostos',
    total: 'Total',
    paid_amount: 'Montante pago',
    order_not_paid: 'Encomenda ainda não foi paga',
    order_paid_online: 'Já pago online',
    cash: 'Pagamento no local',
    this_is_not_an_invoice: 'Isto não é uma fatura',
  },
  delivery_qr_code: {
    scan: 'Digitalizar e entregar com Google Maps',
  },
  delivery_providers: {
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
};
